<template>
    <div class="mt-5">
        <history-wrapper overflowVisible defaultOpened :title="$t('diseases')" hideTitleOnOpen>
            <history-diseases-section @anyItemSelected="diseaseSelected = $event"></history-diseases-section>
        </history-wrapper>
        <history-wrapper overflowVisible defaultOpened :title="$t('chrondiseases')" hideTitleOnOpen>
            <history-chrondiseases-section @anyItemSelected="chronDiseaseSelected = $event"></history-chrondiseases-section>
        </history-wrapper>
        <history-wrapper overflowVisible defaultOpened :title="$t('allergies')" hideTitleOnOpen>
            <history-med-allergies-section @anyItemSelected="medAllergiesSelected = $event"></history-med-allergies-section>
        </history-wrapper>
        <history-wrapper overflowVisible defaultOpened :title="$t('otherAllergies')" hideTitleOnOpen>
            <history-allergies-section @anyItemSelected="allergiesSelected = $event"></history-allergies-section>
        </history-wrapper>
        <history-wrapper overflowVisible defaultOpened :title="$t('currentMedication')" hideTitleOnOpen>
            <history-medicines-section hideReminderDialog @anyItemSelected="medicinesSelected = $event"></history-medicines-section>
        </history-wrapper>
        <base-card>
            <b-row style="gap: 1rem" class="mt-5">
                <b-col cols="12">
                    <h4 v-html="$t('weight')"></h4>
                </b-col>
                <b-col md="2" cols="6">
                    <base-input v-model="localizedPatientWeight" :placeholder="$t('weight')"></base-input>
                </b-col>
                <b-col md="1" cols="4">
                    <base-button @click="saveWeight">{{ $t('save') }}</base-button>
                </b-col>
            </b-row>
            <b-row class="mt-5">
                <b-col cols="12" class="text-center">
                    <back-button class="mr-3" withoutArrow></back-button> <base-button @click="checkHealthData">{{ $t('continue') }}</base-button>
                </b-col>
            </b-row>
        </base-card>
    </div>
</template>

<script>
import HistoryWrapper from '@/components/views/clinicHistory/ClinicHistorySectionWrapper'
import HistoryAllergiesSection from '@/components/shared/HistoryAllergiesSection.vue'
import HistoryMedAllergiesSection from '@/components/shared/HistoryMedAllergiesSection.vue'
import HistoryDiseasesSection from '@/components/shared/HistoryDiseasesSection.vue'
import HistoryChrondiseasesSection from '@/components/shared/HistoryChrondiseasesSection.vue'
import HistoryVaccinesSection from '@/components/shared/HistoryVaccinesSection.vue'
import HistoryMedicinesSection from '@/components/shared/HistoryMedicinesSection.vue'
import BackButton from '@/components/base/buttons/BackButton'
import clinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import { WEIGHT } from '@/constants/clinicHistory'
import BaseCard from '@/components/base/ui/BaseCard'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'clinic-history'

export default {
    components: {
        HistoryWrapper,
        HistoryAllergiesSection,
        HistoryMedAllergiesSection,
        HistoryDiseasesSection,
        HistoryChrondiseasesSection,
        HistoryVaccinesSection,
        HistoryMedicinesSection,
        BackButton,
        BaseCard
    },
    props: {
    },
    data () {
        return {
            diseaseSelected: false,
            chronDiseaseSelected: false,
            medAllergiesSelected: false,
            allergiesSelected: false,
            medicinesSelected: false
        }
    },
    mixins: [i18nMixin(I18N_FILE)],
    computed: {
    localizedPatientWeight: {
        get () {
            const val = this.$store.state.appointmentRequest.appointmentData.patientWeight
            const locale = this.$i18n.locale

            if (typeof val !== 'number' || isNaN(val)) {
                return ''
            }

            const isInt = Number.isInteger(val)

            return new Intl.NumberFormat(locale, {
                minimumFractionDigits: isInt ? 0 : 1,
                maximumFractionDigits: isInt ? 0 : 2
            }).format(val)
        },
        set (val) {
            if (val === '') {
                this.$store.commit('appointmentRequest/setPatientWeight', null)
                return
            }

            const normalized = val.replace(',', '.')
            const endsInDecimal = /[.,]$/.test(val)

            if (endsInDecimal) {
                return
            }

            const parsed = parseFloat(normalized)
            if (!isNaN(parsed)) {
                this.$store.commit('appointmentRequest/setPatientWeight', parsed)
            }
        }
    }
    },
    methods: {
        checkHealthData () {
            if (!this.diseaseSelected) {
                this.$store.dispatch('showInfoAlert', this.$t('decideDisease'))
            } else if (!this.chronDiseaseSelected) {
                this.$store.dispatch('showInfoAlert', this.$t('decideChronDisease'))
            } else if (!this.medAllergiesSelected) {
                this.$store.dispatch('showInfoAlert', this.$t('decideMedAllergy'))
            } else if (!this.allergiesSelected) {
                this.$store.dispatch('showInfoAlert', this.$t('decideAllergies'))
            } else if (!this.medicinesSelected) {
                this.$store.dispatch('showInfoAlert', this.$t('decideMedicine'))
            } else if (this.$store.state.appointmentRequest.weightUpdateRequired && !this.$store.state.appointmentRequest.historyWeightModified) {
                this.$store.dispatch('showInfoAlert', this.$t('weightNeeded'))
            } else {
                this.$emit('checkIfPaymentRequired')
            }
        },
        saveWeight () {
            let data = { aspNetUserId: this.$store.state.session.user.id, values: [this.$store.state.appointmentRequest.appointmentData.patientWeight], variableName: WEIGHT }
            clinicHistoryRepository().saveVariableValue(data).then((response) => {
                if (response.data.data) {
                    this.$store.dispatch('showSuccessAlert', this.$t('weightUpdated'))
                    this.$store.commit('appointmentRequest/setHistoryWeightModified', true)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/webapp/patient/appointment-request/AppointmentRequestHistoryData.vue